import React from 'react'
import styled, { DefaultTheme } from 'styled-components'

const Link = styled.a`
  background-color: Transparent;
  background-repeat: no-repeat;
  border: none;
  overflow: hidden;
  outline: none;
  padding: 0em;
  text-align: center;
  content-align: center;
  align-self: center;
  justify-content: center;
  cursor: pointer;

  :hover{
  	opacity: 0.85;
  }

`

const Img = styled.img`
  height: 2.25rem;
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-self: center;
`

interface Props {
  theme: DefaultTheme
  href: string
}
function Logo({ theme, href }: Props) {
  return (
    <Img src={theme.logo} />
  )
}

export default Logo
